export default "__VITE_ASSET__Dx25nSHr__"